import { createAction, props } from '@ngrx/store';
// ========= Notification Management ==========
export const setNotificationListPageNumber = createAction('[Notification Management] Set Notification List Page Number', props<{ pageNumberNotificationList: number }>());
export const setNotificationListItemsPerPage = createAction('[Notification Management] Set Notification List Items Per Page', props<{ itemsPerPageNotificationList: number }>());

